<template>
    <div class="column full-width">
        <div>
            <q-btn-group class="q-ma-sm toggle-axis-button">
                <q-btn
                    @click="axisType = 'events'"
                    :color="axisType === 'events' ? 'primary' : 'white'"
                    :text-color="axisType === 'events' ? 'white' : 'black'"
                    :label="$t('Quality Events')"
                    no-caps
                />
                <q-btn
                    @click="axisType = 'products'"
                    :color="axisType === 'products' ? 'primary' : 'white'"
                    :text-color="axisType === 'products' ? 'white' : 'black'"
                    :label="$t('Rejected Products')"
                    no-caps
                />
            </q-btn-group>
        </div>
        <div>
            <quality-chart
                :report="report"
                :comparisonReport="comparisonReport"
                :axisType="axisType"
                :facility="facility"
                :selectedGroupBy="selectedGroupBy"
            ></quality-chart>
            <quality-chart
                v-if="comparisonReport"
                :report="comparisonReport"
                :comparisonReport="report"
                :isComparison="true"
                :axisType="axisType"
                :facility="facility"
                :selectedGroupBy="selectedGroupBy"
            ></quality-chart>
        </div>
    </div>
</template>

<script>
import QualityChart from './QualityChart.vue';

export default {
    name: 'QualityDashboard',
    components: { QualityChart },
    props: {
        report: {
            type: Object,
            required: true
        },
        comparisonReport: {
            type: Object,
            required: false
        },
        facility: {
            type: Number,
            required: true
        },
        selectedGroupBy: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            // toggle axis type ('events' or 'products')
            axisType: 'events'
        };
    }
};
</script>

<style lang="scss" scoped>
.toggle-axis-button {
    height: 35px;
}
</style>
